import { useSort } from "@b2bportal/core-flights";
import {
  IconNameEnum,
  useFlightStyles,
  useModuleBEM,
} from "@b2bportal/core-themes";
import {
  CoreFlightsComponent,
  type PlatformComponentProps,
  type SortOptionEnum,
} from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import {
  Icon,
  Popover,
  PopoverContent,
  PopoverTrigger,
  RadioGroup,
} from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./Sort.module.scss";

export interface SortComponentProps extends PlatformComponentProps {
  value: SortOptionEnum;
  handleSortChange: (value: string) => void;
}

export const Sort = ({
  children,
  className,
  value,
  handleSortChange,
}: SortComponentProps) => {
  const COMPONENT_KEY = CoreFlightsComponent.Sort;
  const styles = useFlightStyles(COMPONENT_KEY, defaultStyles);
  const [, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { t } = useI18nContext();

  const {
    context: { sortOptions },
    handlers: { getSortLabelKey },
  } = useSort();

  return (
    <Popover>
      <PopoverTrigger className={clsx(cn("sort-button"), className)}>
        <span className={cn("sort-label")}>
          <strong>{t("core-flights.sort.dropDownLabel")}</strong>
          {getSortLabelKey(value)}
        </span>
        <Icon iconName={IconNameEnum.dropdownTriangle} />
      </PopoverTrigger>
      <PopoverContent className={clsx(cn("sort-content"), className)}>
        <RadioGroup
          options={sortOptions}
          selectedOption={value}
          onSelectValue={(selectedValue) => handleSortChange(selectedValue)}
          className={cn("radio-group")}
        />
        {children}
      </PopoverContent>
    </Popover>
  );
};
